import React from "react";
import { ContratosPage } from "./contratos.page";
import { ContratosProvider } from "./context/contratos-context";

export function ContratosFactory() {
    return (
        <ContratosProvider>
            <ContratosPage></ContratosPage>
        </ContratosProvider>
    );
}
